import { render, staticRenderFns } from "./hospitalSuccess.vue?vue&type=template&id=625331e4&scoped=true&"
import script from "./hospitalSuccess.vue?vue&type=script&lang=js&"
export * from "./hospitalSuccess.vue?vue&type=script&lang=js&"
import style0 from "./hospitalSuccess.vue?vue&type=style&index=0&id=625331e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625331e4",
  null
  
)

export default component.exports